import { render, staticRenderFns } from "./DeFrame.vue?vue&type=template&id=b127dfbc"
import script from "./DeFrame.vue?vue&type=script&lang=js"
export * from "./DeFrame.vue?vue&type=script&lang=js"
import style0 from "./DeFrame.vue?vue&type=style&index=0&id=b127dfbc&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b127dfbc')) {
      api.createRecord('b127dfbc', component.options)
    } else {
      api.reload('b127dfbc', component.options)
    }
    module.hot.accept("./DeFrame.vue?vue&type=template&id=b127dfbc", function () {
      api.rerender('b127dfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/DeFrame.vue"
export default component.exports